import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';
import { Link } from 'react-router-dom';

export const CarouselMain = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  return (
    <Carousel activeIndex={index} onSelect={handleSelect}>
      <Carousel.Item>
        <Carousel.Caption>
          <h1>Create your first NFT meme!</h1>
          <p>You can quickly create your own NFT meme saved in IPFS.</p>
          <Link to="/create">
            <button className="btn btn-success">Create NFT</button>
          </Link>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <Carousel.Caption>
          <h1>What is MeraMeme</h1>
          <p>
            MeraMeme is a platform for meme lords to make memes and mint them as
            NFT and preserve rights to them. Users can use our meme generator to
            make memes and mint them as NFTS
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
};
